import React from "react";
import { Link } from "react-router-dom";
import ExcellentExport from "excellentexport";

import * as Type from "@interface/index";
import Connector from "@helpers/Connector";
import PreloaderComponent from "@components/preloader/PreloaderComponent";

import Style from "../Cutaways.module.scss";

interface PropsInterface extends Type.ComponentInterface {}

interface StateInterface {}

export default Connector(
  class CutawayListPage extends React.Component<
    PropsInterface,
    StateInterface
  > {
    public constructor(props: PropsInterface) {
      super(props);
      this.downloadExcel = this.downloadExcel.bind(this);
    }

    public downloadExcel() {
      const link = document.createElement("a");

      const convertedTable: any[] = [];
      this.props.Store.User.Cutaway.list?.forEach((Cutaway: any) => {
        convertedTable.push([
          Cutaway.data.fullName || "",
          Cutaway.data.position || "",
          Cutaway.data.companyTitle || "",
          Cutaway.data.email || "",
          Cutaway.data.phone || "",
        ]);
      });

      ExcellentExport.convert(
        {
          anchor: link,
          format: "xls",
          filename: "Cutaways",
        },
        [
          {
            name: "Cutaways",
            from: {
              array: convertedTable,
            },
          },
        ]
      );

      document.body.appendChild(link);
      link.click();
      link.remove();
    }

    public render() {
      const userCutaway = this.props.Store.User.Cutaway;

      return (
        <div className={Style.cutaways}>
          {userCutaway.status !== "loaded" ? (
            <div className={Style.message}>
              <PreloaderComponent />
            </div>
          ) : userCutaway?.list?.length ? (
            <div className={`${Style.message} ${Style.messageDownload}`}>
              <div className={Style.messageCol}>
                <div className={Style.messageTitle}>
                  Скачайте все контакты файлом-таблицей
                </div>
                <div className={Style.messageText}>
                  Скачивание визиток будет доступно до конца выставки.
                </div>
              </div>
              <div className={Style.messageCol}>
                <Link
                  to="#"
                  id="cutaway-xls-download"
                  className="btn btn--red"
                  onClick={this.downloadExcel}
                >
                  Выгрузить контакты&nbsp;.xls
                </Link>
              </div>
            </div>
          ) : (
            <div className={Style.message}>
              <div className={Style.messageCol}>
                <div className={Style.messageTitle}>Пока тут ничего нет</div>
                <div className={Style.messageText}>
                  Визитки из этого раздела вы можете скачать файлом-таблицей,
                  когда тут появятся данные. Чтобы начать общение{" "}
                  <Link to="/networking" className={Style.messageLink}>
                    перейдите в Нетворкинг
                  </Link>
                  .
                </div>
              </div>
            </div>
          )}
          {userCutaway?.list?.map((Cutaway: any) => {
            return (
              <div className={Style.cutaway_saved} key={Cutaway.id}>
                <div className={Style.persona}>
                  <figure className={Style.personaPhoto}>
                    {Cutaway.data?.userImage ? (
                      <img src={Cutaway.data?.userImage || ""} alt="" />
                    ) : (
                      <div className={Style.personaBgAvatar} />
                    )}
                  </figure>
                  <div className={Style.personaName}>
                    <div>{Cutaway.data?.fullName}</div>
                  </div>
                  <div className={Style.personaPosition}>
                    {Cutaway.data?.position}{" "}
                    {Cutaway.data?.companyTitle ? (
                      <>, {Cutaway.data?.companyTitle}</>
                    ) : null}
                  </div>
                </div>
                <div className={Style.contacts}>
                  <a href={`mailto:${Cutaway.data?.email}`}>
                    {Cutaway.data?.email}
                  </a>
                  <a href={`tel:${Cutaway.data?.phone}`}>
                    {Cutaway.data?.phone}
                  </a>
                </div>
                <div className={Style.company}>
                  {Cutaway.data?.companyTitle ? (
                    <div className={Style.companyImg}>
                      <img
                        src={
                          Cutaway.data?.companyImage ||
                          require("@public/images/defaultAvatarCompany.svg")
                        }
                        alt=""
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      );
    }
  }
);
